const state = {
    color:"#006bb9"
}
export default state;